/* global SERVER_BASE_URL */
import fetch from 'isomorphic-fetch'

import processError from '../helpers/processError'
import { getToken } from '@auth/token-service'
import {
  GET_MAP_OVERLAY_REQUEST,
  GET_MAP_OVERLAY_SUCCESS,
  GET_MAP_OVERLAY_FAILURE,
} from '../constants/actionTypes'

function getMapOverlayRequest() {
  return {
    type: GET_MAP_OVERLAY_REQUEST,
    isFetchingOverlay: true,
  }
}

function getMapOverlaySuccess(overlay, overlayType, fipsQuery) {
  return {
    type: GET_MAP_OVERLAY_SUCCESS,
    isFetchingOverlay: false,
    overlay,
    overlayType,
    fipsQuery,
  }
}

function getMapOverlayFailure(message) {
  return {
    type: GET_MAP_OVERLAY_FAILURE,
    isFetchingOverlay: false,
    message,
  }
}

export function getMapOverlay(type, states, counties, jwt = null) {
  const authToken = jwt || getToken()
  let url = `${SERVER_BASE_URL}/api/companies/overlay?type=${type || ''}`
  if (counties) {
    url += counties.map(county => `&county=${county}`).join('')
  }
  if (states) {
    url += states.map(state => `&state=${state}`).join('')
  }
  const config = {
    method: 'GET',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  }
  return (dispatch, getState) => {
    // if we don't have this data in the store, fetch it
    const mapState = getState().map
    let fipsQuery = ''
    let overlayData = mapState.countyOverlay
    // determine fips code based on assumption we search by one state/county at a time.
    fipsQuery = states[0]
    if (type === 'zip' && counties) {
      // add on county code
      fipsQuery += counties[0]
      overlayData = mapState.zipOverlay
    }
    if (overlayData[fipsQuery]) {
      return
    }
    dispatch(getMapOverlayRequest())
    return fetch(url, config).then(response => {
      response.json().then(result => ({ result, response })).then(({ result, response }) => {
        if (!response.ok) {
          dispatch(getMapOverlayFailure(processError(result)))
          return Promise.reject(result)
        } else {
          dispatch(getMapOverlaySuccess(result, type, fipsQuery))
        }
      }).catch((err) => console.log(err))
    })
  }
}
